import React from 'react';
import { DashboardModal } from 'containers/Dashboard/components/DashboardModal';
import { Alert } from 'reactstrap';
import __ from 'utils/i18n';

export const RequestCardUpdateModal = ({ 
  showModal = false, 
  hideModal, 
  subscriber, 
  submitAction, 
  submitDisabled = false 
}) => {
  if (!subscriber) return null;

  const customerName = subscriber.customer?.fullName || __('dashboard.sections.recurringPayments.subscribers.requestCardUpdateModal.defaultCustomer');

  return (
    <DashboardModal
      name="requestCardUpdateModal"
      headerText={__('dashboard.sections.recurringPayments.subscribers.requestCardUpdateModal.title')}
      showModal={showModal}
      hideModal={hideModal}
      submitAction={submitAction}
      submitColor="primary"
      submitDisabled={submitDisabled}
      hideSeparator={true}
      cancelText={__('dashboard.sections.recurringPayments.subscribers.requestCardUpdateModal.cancelButton')}
      submitText={submitDisabled 
        ? __('dashboard.sections.recurringPayments.subscribers.requestCardUpdateModal.sending')
        : __('dashboard.sections.recurringPayments.subscribers.requestCardUpdateModal.confirmButton')
      }
    >
      <div className="recurring-payments-text-wrap">
        <p className="mb-3">
          {__('dashboard.sections.recurringPayments.subscribers.requestCardUpdateModal.description', { customerName })}
        </p>
        
        <Alert color="info" className="d-flex align-items-start mb-0">
          <i className="mdi mdi-information mr-2 mt-1" style={{ fontSize: '20px' }}></i>
          <div className="recurring-payments-text-wrap">
            <strong className="d-block mb-1">
              {customerName}
            </strong>
            <span>
              {subscriber.customer?.email || '-'}
            </span>
          </div>
        </Alert>
      </div>
    </DashboardModal>
  );
};

